const getExternalId = (obj: Record<string, any> | null | undefined): string | undefined => {
    if (!obj) return undefined;
    return obj.externalId || obj.external_id;
};

export default getExternalId;
